import styled from "styled-components";
import theme from "../../../../../Styles/theme";


export const Container = styled.div``;


export const HandleCentralize = styled.div`

    width:100%;
    display: flex;
    align-items: center;
    justify-content:center;
`;

interface TipoButtonProps{
    focus: boolean;
}
export const TipoButton = styled.button<TipoButtonProps>`
    width:40%;
    border-radius: 0.25rem;
    background-color: ${({ focus })=>focus?theme.colors.darkGrey: theme.colors.light2};
    font-size: max(1.2vw, 10px);
    color: ${theme.colors.dark};
    padding: 0.8vh 1vw;
    margin-top:1vh;
    &:hover {
        opacity: 0.7;
    }

`;